import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider }     from "./context/CartContext";
import { ProductProvider }  from "./context/ProductContext";
import { AuthProvider }     from "./context/AuthContext";
import { WishlistProvider } from "./context/WishlistContext";
import Navbar        from "./components/Navbar";
import Footer        from "./components/Footer";
import Home          from "./pages/Home";
import Shop          from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart          from "./pages/Cart";
import Wishlist      from "./pages/Wishlist";
import Account       from "./pages/Account";
import Admin         from "./pages/Admin";
import Checkout      from "./pages/Checkout";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <WishlistProvider>
      <ProductProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              {/* Admin — no navbar/footer */}
              <Route path="/admin"    element={<Admin />} />

              {/* Main site */}
              <Route path="*" element={
                <>
                  <Navbar />
                  <Routes>
                    <Route path="/"            element={<Home />} />
                    <Route path="/shop"        element={<Shop />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/cart"        element={<Cart />} />
                    <Route path="/checkout"    element={<Checkout />} />
                    <Route path="/wishlist"    element={<Wishlist />} />
                    <Route path="/account"     element={<Account />} />
                    <Route path="*"            element={<Home />} />
                  </Routes>
                  <Footer />
                </>
              } />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </ProductProvider>
      </WishlistProvider>
    </AuthProvider>
  );
}
